// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/App.css */
body {
    font-family: Arial, sans-serif;
}

button {
    background-color: #4CAF50; /* Green */
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 4px;
}

button:disabled {
    background-color: #ccc;
}

table {
    width: 80%;
    margin: auto;
    border-collapse: collapse;
}

th, td {
    border: 1px solid #ddd;
    padding: 8px;
}

th {
    background-color: #f2f2f2;
}

/* 添加响应式设计规则 */
.navbar {
    margin-bottom: 20px;
}

@media (max-width: 768px) {
    .navbar-nav {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .nav-item {
        margin-bottom: 10px;
    }

    .container-fluid {
        justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI,8BAA8B;AAClC;;AAEA;IACI,yBAAyB,EAAE,UAAU;IACrC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,cAAc;AACd;IACI,mBAAmB;AACvB;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":["/* src/App.css */\r\nbody {\r\n    font-family: Arial, sans-serif;\r\n}\r\n\r\nbutton {\r\n    background-color: #4CAF50; /* Green */\r\n    border: none;\r\n    color: white;\r\n    padding: 10px 20px;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    display: inline-block;\r\n    font-size: 16px;\r\n    margin: 4px 2px;\r\n    cursor: pointer;\r\n    border-radius: 4px;\r\n}\r\n\r\nbutton:disabled {\r\n    background-color: #ccc;\r\n}\r\n\r\ntable {\r\n    width: 80%;\r\n    margin: auto;\r\n    border-collapse: collapse;\r\n}\r\n\r\nth, td {\r\n    border: 1px solid #ddd;\r\n    padding: 8px;\r\n}\r\n\r\nth {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\n/* 添加响应式设计规则 */\r\n.navbar {\r\n    margin-bottom: 20px;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .navbar-nav {\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n    }\r\n\r\n    .nav-item {\r\n        margin-bottom: 10px;\r\n    }\r\n\r\n    .container-fluid {\r\n        justify-content: center;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
